import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="nf-body">
      <main className="card" role="main" aria-labelledby="title">
        <section className="left" aria-hidden="false">
          <div className="eyebrow">404 • Page not found</div>
          <h1 id="title" className="title">We can't find that page.</h1>
          <p className="desc">
            The link you followed may be broken, or the page may have been removed.
            Don't worry — you can go back to the homepage or contact support if you need help.
          </p>

          <div className="actions">
            <Link className="btn" to="/">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M3 11.5L12 4l9 7.5" stroke="#091023" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M5 21V11h14v10" stroke="#091023" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Home
            </Link>

            <button className="btn secondary" onClick={() => (window.location.href = "/")}>
              Search site
            </button>
          </div>

          <p className="small" style={{ marginTop: 14 }}>
            Tip: If you typed the URL manually, double-check for typos.
          </p>
        </section>

        <aside className="right" aria-hidden="true">
          <div className="orbit">
            <div>
              <div className="big">404</div>
              <div className="small">Page not found</div>
            </div>
          </div>
        </aside>
      </main>
      {/* Custom Styles */}
      <style>{`
        :root {
  --bg:#0f1724;
  --card:#0b1220;
  --accent:#f97316;
  --muted:#93a3b8;
  --glass: rgba(255,255,255,0.04);
  --radius:18px;
  --max-width:1000px;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI",
               Roboto, "Helvetica Neue", Arial;
}

/* Background */
.nf-body {
  height:100vh;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:24px;
  background:
    radial-gradient(1200px 600px at 10% 10%, rgba(249,115,22,0.08), transparent 6%),
    radial-gradient(900px 400px at 90% 90%, rgba(99,102,241,0.04), transparent 8%),
    var(--bg);
  color:#e6eef8;
}

/* Card */
.card {
  width:100%;
  max-width:var(--max-width);
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border-radius:var(--radius);
  padding:32px;
  box-shadow: 0 8px 30px rgba(2,6,23,0.6);
  display:flex;
  gap:28px;
  align-items:center;
  justify-content:space-between;
}

.left { flex:1 1 420px; min-width:220px; }

.eyebrow {
  display:inline-flex;
  align-items:center;
  gap:10px;
  margin-bottom:8px;
  color:var(--accent);
  font-weight:600;
  font-size:13px;
}

.title {
  margin:0 0 12px 0;
  font-size: clamp(28px, 4.6vw, 44px);
  line-height:1.02;
  color:#fff;
}

.desc {
  margin:0 0 18px 0;
  color:var(--muted);
  font-size:clamp(14px, 2.2vw, 16px);
}

.actions {
  display:flex;
  gap:12px;
  flex-wrap:wrap;
}

.btn {
  display:inline-flex;
  align-items:center;
  gap:10px;
  padding:12px 18px;
  border-radius:12px;
  border:0;
  cursor:pointer;
  font-weight:600;
  text-decoration:none;
  color:#091023;
  background:var(--accent);
  box-shadow: 0 6px 18px rgba(249,115,22,0.16);
}

.btn.secondary {
  background:transparent;
  color:var(--muted);
  border:1px solid rgba(255,255,255,0.04);
  box-shadow:none;
}

/* Right Illustration */
.right {
  width:260px;
  flex:0 0 260px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.orbit {
  width:220px;
  height:220px;
  border-radius:999px;
  background: conic-gradient(from 200deg, rgba(249,115,22,0.08), transparent 30%, rgba(99,102,241,0.06));
  display:grid;
  place-items:center;
  box-shadow: inset 0 -12px 40px rgba(2,6,23,0.6), 0 6px 24px rgba(2,6,23,0.6);
  border:1px solid rgba(255,255,255,0.02);
}

.orbit .big { font-size:56px; color:#fff; font-weight:700; }
.orbit .small { color:var(--muted); font-size:12px; margin-top:6px; }

/* Responsive */
@media (max-width:820px) {
  .card { flex-direction:column-reverse; padding:22px; gap:18px; }
  .right { width:160px; flex:0 0 160px; }
  .orbit { width:140px; height:140px; }
  .orbit .big { font-size:34px; }
}

@media (max-width:420px) {
  .nf-body { padding:16px; }
  .card { padding:18px; }
  .title { font-size:26px; }
}

      `}</style>
    </div>
  );
};

export default NotFound;